// Libs
import React from 'react';

//-------------------------------------------------------------------------------------------------------------------

class SideBar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    render() {
        const { content, className } = this.props;
        const { isOpen } = this.state;

        return (
            <aside className={`side-bar ${isOpen ? 'open' : ''} ${className || ''}`}>
                <div className="side-bar-content">
                    {content}
                </div>
            </aside>
        );
    }
}

export default SideBar;
